import { currentUser } from "@/App";
import PostTabs from "@/components/PostTabs";
import ScheduledNoteCard from "@/components/ScheduledNoteCard";
import { SubscribedProvider } from "@/providers/Subscribed";
import { useScheduled } from "@/services/hooks";
import { Add, Close, ScheduleSend } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Skeleton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Scheduled() {
  const { data: scheduled, isLoading } = useScheduled();
  const navigate = useNavigate();

  return (
    <SubscribedProvider artistKey={currentUser.key}>
      <Box sx={{ mb: 10 }}>
        <PageAppBar />
        <PostTabs />

        <Container maxWidth="sm" sx={{ mt: 10 }}>
          <Button
            onClick={() => navigate("/post")}
            variant="outlined"
            color="primary"
            fullWidth
            size="large"
            startIcon={<Add />}
            sx={{ mb: 4 }}
          >
            New Scheduled Post
          </Button>
          {isLoading && (
            <>
              <Skeleton
                variant="rectangular"
                height={100}
                sx={{ my: 2, borderRadius: "25px" }}
              />
              <Skeleton
                variant="rectangular"
                height={100}
                sx={{ my: 2, borderRadius: "25px" }}
              />
              <Skeleton
                variant="rectangular"
                height={100}
                sx={{ my: 2, borderRadius: "25px" }}
              />
            </>
          )}
          {scheduled?.map((content) => (
            <ScheduledNoteCard key={content.key} content={content} />
          ))}
        </Container>
      </Box>
    </SubscribedProvider>
  );
}

function PageAppBar({}) {
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{ background: "rgba(19,19,19,.9)" }}
    >
      <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
        <IconButton onClick={() => navigate(-1)} sx={{ pl: 0 }}>
          <Close />
        </IconButton>
        <Stack direction="row" alignItems="center" gap={1}>
          <ScheduleSend color="primary" />
          <Typography variant="h6">Scheduled Posts</Typography>
        </Stack>
        <Box sx={{ width: "24px" }} />
      </Toolbar>
    </AppBar>
  );
}
